module.exports = __webpack_public_path__ + "af19b9950fb54ec29ce1630d0453fbe0.svg";